<template>
    <div class="animated fadeIn">
        <loading :active.sync="disabledField"></loading>
        <notifications group="foo" />
        <b-row class="text-right">
            <b-col cols="6" sm="4" md="2" class="mb-3">
                <b-button size="sm" block v-bind:variant="btnConnectClass()" v-on:click="changeWidgetStatus()" :disabled="btnChangeDisabled()">{{btnConnectText()}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header">
                        <b-row >
                            <b-col cols="6" sm="6" md="6">
                                <i class="fa fa-edit"></i><strong> Триггеры</strong> 
                            </b-col>
                            <b-col cols="6" sm="6" md="6" class="text-right">
                                <b-button type="submit" right size="sm" variant="" v-on:click="addTrigger()"><i class="fa fa-plus"></i> Добавить триггер</b-button>
                            </b-col>
                        </b-row>
                    </div>
                    <div>
                        <b-card class="mb-3" v-for="item in settings" style="width: 100%">
                            <b-row class="mb-2">
                                <b-col cols="4">Воронка продаж:</b-col>
                                <b-col cols="8">
                                    <b-form-select v-model="item.pipeline" @change="setStatuses($event)">
                                        <option v-for="pipeline in pipelines" :value="pipeline.id">{{ pipeline.name }}</option>
                                    </b-form-select>
                                </b-col>
                            </b-row>

                            <b-row class="mb-2">
                                <b-col cols="4">Начальный этап:</b-col>
                                <b-col cols="8"><b-form-select v-model="item.startStatus">
                                    <option v-for="status in pipelineStatuses" :value="status.id">{{ status.name }}</option>
                                </b-form-select></b-col>
                            </b-row>

                            <b-row class="mb-2">
                                <b-col cols="4">Целевой этап:</b-col>
                                <b-col cols="8"><b-form-select v-model="item.endStatus">
                                    <option v-for="status in pipelineStatuses" :value="status.id">{{ status.name }}</option>
                                </b-form-select></b-col>
                            </b-row>

                            <b-row class="mb-2">
                                <b-col cols="4">Поле типа "Дата"</b-col>
                                <b-col cols="8"><b-form-select :options="amoLeadFields" v-model="item.field"></b-form-select></b-col>
                            </b-row>

                            <b-row class="mb-2">
                                <b-col cols="4">Отклонение (в часах)</b-col>
                                <b-col cols="8"> <b-input v-model="item.DateDiff" placeholder="Отклонение" type="number"></b-input></b-col>
                            </b-row>

                            <b-row class="mb-2">
                                <b-col cols="4">Часовой пояс:</b-col>
                                <b-col cols="8"><b-form-select v-model="item.timezone">
                                    <option v-for="timezone in timezones" :value="timezone.value">{{ timezone.text }}</option>
                                </b-form-select></b-col>
                            </b-row>

                            <b-button class="mt-2" href="#" variant="danger">Удалить</b-button>
                        </b-card>
                    </div>

                    <div slot="footer">
                        <b-button type="submit" :disabled="!widget.isActive" size="sm" variant="primary" v-on:click="saveSettings()"><i class="fa fa-save"></i> Сохранить</b-button>
                    </div>
                </b-card>
            </b-col>

            <b-col md="6">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header"> <i class="icon-notebook icons"></i><strong> Описание</strong></div>
                    <p>Для оперативного анализа большого потока сделок иногда не достаточно суммы по Бюджету на каждом этапе. Данный виджет позволяет выводить в "шапку" под заголовками этапов дополнительные суммы по выбранным числовым полям в сделке.</p>
                </b-card>
            </b-col>
        </b-row>
  </div>
</template>

<script>
    import WidgetsService from '@/services/WidgetsService'
    import widgetEvents from '@/views/widgets/Widget';
    import VueTribute from 'vue-tribute'
    import timezones from '@/services/timezones.json'

    export default {
        mixins: [
            widgetEvents
        ],
        components: { VueTribute }, 
        name: 'ExtendSumHeader',
        data () {
            return {
                widget: { isActive : false },
                widgetId: '5d26edd01ddcb73c6c7a14c3',
                amoLeadFields : [],
                pipelines : [],
                settings: [],
                disabledField: false,
                onLoad: false,
                pipelineStatuses: [],
                timezones: timezones
            }
        },
        computed: {

        },
        watch: {
            selectPipeline: function (value) {
                console.log(value);
                for (var key in this.pipelines) {
                   if(key == value) {
                       this.pipelineStatuses = this.pipelines[key].statuses;
                   }
                }
            }
        },
        created: function () {
            this.disabledField = true;  
            this.getWidget(() => {
                this.getPipelines();
                this.getLeadFields();
                this.disabledField = false;
            });
        },
        methods: {
            setStatuses : function() {
                for (var key in this.pipelines) {
                   if(key == event.target.value) {
                       this.pipelineStatuses = this.pipelines[key].statuses;
                   }
                }
            },
            async getLeadFields () {
                await WidgetsService.getLeadFields([6]).then(response => {
                    this.amoLeadFields = response.data.result;
                }).catch(err => { return console.log(err); });
            },
            async getPipelines () {             
                await WidgetsService.getPipelines().then(response => {               
                    this.pipelines = response.data.data.result.items;
                }).catch(err => { return console.log(err); });
            },
            addTrigger : function (){
                this.settings.push({
                    pipeline: 0,
                    startStatus: 0,
                    endStatus: 0,
                    field: 0,
                    dateDiff: 0,
                    timezone: 'Moscow Standard Time',
                });
            },
            removeTrigger(item) {
                this.settings.splice(this.settings.indexOf(item), 1);
                this.saveSettings();
            },
        },
    };
    
</script>